import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../core/auth/services/auth.service';
import { BehaviorSubject, Subscription, of } from 'rxjs';
import { distinctUntilChanged, switchMap, catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'imageUrl',
  pure: false
})
export class ImageUrlPipe implements PipeTransform, OnDestroy {
  private latestValue: SafeUrl | string | null = '';
  private subscription = new Subscription();
  private subject = new BehaviorSubject<string | null>(null);

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {
    this.init();
  }

  transform(value: any): SafeUrl | null {
    if (!value) return null;

    let url: string;

    if (value instanceof File) {
      return URL.createObjectURL(value);
    }

    if (typeof value === 'string') {
      url = value.startsWith('http') || value.startsWith('data:image')
        ? value
        : `${value.startsWith('/') ? environment.api_url : environment.api_url + '/'}${value}`;
    } else if (value?.image) {
      url = value.image.startsWith('http')
        ? value.image
        : `${environment.api_url}${value.image}`;
    } else {
      return null;
    }

    this.subject.next(url);
    return this.latestValue || null;
  }

  private init() {
    this.subscription = this.subject.pipe(
      distinctUntilChanged(),
      switchMap(url => {
        if (!url) return of(null);

        const token = this.authService.getToken();
        const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;

        return this.http.get(url, { responseType: 'blob', headers }).pipe(
          map(blob => {
            const objectUrl = URL.createObjectURL(blob);
            return this.sanitizer.bypassSecurityTrustUrl(objectUrl);
          }),
          catchError(() => of(null)),
          tap(result => {
            this.latestValue = result;
            this.cdr.markForCheck(); 
          })
        );
      })
    ).subscribe();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
